module.exports = __webpack_public_path__ + "img/blue-icon-icon.710cc92c.svg";